import React from "react";

// reactstrap components

// core components
import Header from "components/Headers/UtilizationHeader.js";

const Pays = (props) => {
    return (
        <>
            <Header account={props.location.state} key="header"/>
        </>
    )
}

export default Pays;